import styled from 'styled-components';

export const MicroLocationInsightsStyles = styled.section``;
